import { environment } from '../../../../../environments/environment';

export const INTERNAL_APPLICATIONS_ENDPOINT = `${environment.apiBaseUrl}/internal/mac/applications`;

export const INTERNAL_APPLICATIONS_PAGED_ENDPOINT = `${environment.apiBaseUrl}/internal/mac/applications/paged`;

export const INTERNAL_MAC_OSCILAR_HOOK_ENDPOINT = `${environment.apiBaseUrl}/internal/mac/applications/oscilar-hook`;
